
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { useMutation } from '@apollo/client';
import { useRef, useState} from 'react';

import { CancelIcon, SaveIcon } from '../../../common/icons';
import { IAddressUsage } from '../../../../types/contact';
import { notifySuccess } from '../../../../services/notification';
import SpinnerOverlay from '../../../common/spinner/spinner';
import AddressDetails, { AddressHandler } from '../../../org/contact-info/org-address/address-details';
import { GET_POSITION_ADDRESSES, UPDATE_POSITION_ADDRESS } from '../../../../graphql/contact-gql';
import Button from '../../../common/button';

type AddressUpdateProps = {
    addressUsage?: IAddressUsage;
    isRole: boolean;
    isOpen: boolean;
    toggle: () => void;
}

const AddressUpdate = (props: AddressUpdateProps) => {
    const {addressUsage, isRole, isOpen, toggle} = props

    const [validated, setValidated] = useState<boolean>(false)
    const addressFormRef = useRef<AddressHandler>(null);
    const [updatePositionAddress, {loading}] = useMutation(UPDATE_POSITION_ADDRESS);
    const [typeaheadError, setTypeaheadError] = useState<string>("");

    const onSaveAddress = () => {
        if (addressFormRef.current && !addressFormRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let addressInput = addressFormRef.current && addressFormRef.current.getAddress();

        updatePositionAddress({
            variables: {
                positionId: addressUsage?.businessEntityId,
                address: addressInput
            },
            refetchQueries: [{
                query: GET_POSITION_ADDRESSES,
                variables: { positionId: addressUsage?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        });
    }

    const onChange = () => {
        setValidated(!!addressFormRef?.current && addressFormRef.current.validate(false))
    }

    return (<>
            {loading && <SpinnerOverlay />}
            <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
                <ModalHeader toggle={toggle} tag={'h2'}>Update a {isRole ? 'Role' : 'Position'} Address</ModalHeader>
                <ModalBody>
                    <AddressDetails addressUsage={addressUsage} ref={addressFormRef} mandatory={true} onChange={onChange} onError={setTypeaheadError} autoFocus={true}/>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={onSaveAddress} disabled={!validated||!typeaheadError}>
                        <SaveIcon/>
                        &nbsp;Update
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        <CancelIcon/>
                        &nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default AddressUpdate;
